import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const infoListDefaultVariants = {}
const infoListCompoundVariants = []

const infoListSlotNames = [
  [
    "root",
    "info-list__root"
  ],
  [
    "row",
    "info-list__row"
  ],
  [
    "columnLeft",
    "info-list__columnLeft"
  ],
  [
    "columnRight",
    "info-list__columnRight"
  ]
]
const infoListSlotFns = /* @__PURE__ */ infoListSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, infoListDefaultVariants, getSlotCompoundVariant(infoListCompoundVariants, slotName))])

const infoListFn = memo((props = {}) => {
  return Object.fromEntries(infoListSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const infoListVariantKeys = []
const getVariantProps = (variants) => ({ ...infoListDefaultVariants, ...compact(variants) })

export const infoList = /* @__PURE__ */ Object.assign(infoListFn, {
  __recipe__: false,
  __name__: 'infoList',
  raw: (props) => props,
  variantKeys: infoListVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, infoListVariantKeys)
  },
  getVariantProps
})